import type * as RadixPopover from '@radix-ui/react-popover';
import type { PropsWithChildren } from 'react';

import { Popover } from '~/chords/Popover';

import { IconButton } from '../IconButton';
import type { IconButtonProps } from '../IconButton/IconButton';
import { KebabMenuItem } from './components/KebabMenuItem';

type IconButtonSize = NonNullable<IconButtonProps['size']>;
type IconButtonVariant = NonNullable<IconButtonProps['iconVariant']>;

export type KebabMenuProps = PropsWithChildren<{
  size?: IconButtonSize;
  iconVariant?: IconButtonVariant;
  /**
   * Callback fired when focus moves into the menu content after it opens.
   * Call `event.preventDefault()` to prevent the default focus behavior
   * (e.g. to keep focus on the trigger).
   */
  onOpenAutoFocus?: RadixPopover.PopoverContentProps['onOpenAutoFocus'];
}>;

export function KebabMenuComponent({
  children,
  size = 'large',
  iconVariant = 'solid',
  onOpenAutoFocus,
}: KebabMenuProps) {
  return (
    <Popover
      content={children}
      stopPropagation
      triggerAsChild
      onOpenAutoFocus={onOpenAutoFocus}
    >
      <IconButton
        aria-label="open options menu"
        iconType="ellipsis-vertical"
        size={size}
        iconVariant={iconVariant}
      />
    </Popover>
  );
}

KebabMenuComponent.displayName = 'KebabMenu';

export const KebabMenu = Object.assign(KebabMenuComponent, {
  Item: KebabMenuItem,
});
